<script>
import Contact from "./Components/Contact.svelte";
import LeaseStudio from "./Components/LeaseStudio.svelte";
import MenuLinks from "./Components/MenuLinks.svelte";
import SalonDirectory from "./Components/SalonDirectory.svelte";
import Services from "./Components/Services.svelte";
import WecomeBlock from "./Components/WecomeBlock.svelte";

import { onMount } from 'svelte';

	let logo = 'images/a-la-mode-logo.png';

	const menuLinks = [
        {
            name: "Salon Directory",
            atag: "#SalonDirectory"
        },
        {
            name: "Lease a Studio",
            atag: "#Lease"
        },
        {
            name: "Contact",
            atag: "#Contact"
        }
	];

	function handleToggle() {
		document.querySelector('.menu__toggler').classList.toggle('active');
		document.querySelector('.menu').classList.toggle('active');
	}

</script>
<header>
	<div class="menu flex-row">
		<a class="logo" href="/"><img src={logo} alt="A La Mode Studios" style="max-height: 60px;"/></a>
		<ul class="flex-row menu-links-list">
			{#each menuLinks as link (link)}
				<MenuLinks link={link.atag} linkTitle={link.name} />
			{/each}
		</ul>
	</div>
	<div class="menu__toggler" on:click="{event => handleToggle()}">
		<span></span>
	</div>
</header>

<main class="main-content">
	<WecomeBlock />
	<Services />
	<SalonDirectory />
	<LeaseStudio />
	<Contact />
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 64px auto 0;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>